/**
 * Tela de erro das rotas (errorElement), no lugar do "Unexpected Application Error!" do React
 * Router. Arquivo de tela que sumiu numa publicação recarrega a página (lib/chunkReload); os
 * demais erros mostram uma mensagem curta com o botão Recarregar.
 */
import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ShellSkeleton } from '../components/common/Skeleton';
import { isChunkLoadError, isReloadingForUpdate, reloadForUpdate } from '../lib/chunkReload';
import { reportClientError } from '../lib/activity/observers';

export function RouteError(): JSX.Element {
  const error = useRouteError();
  const { t } = useTranslation();
  const chunk = isChunkLoadError(error);
  const reloading = isReloadingForUpdate() || (chunk && reloadForUpdate());

  useEffect(() => {
    if (reloading) return;
    reportClientError('route', error);
  }, [error, reloading]);

  if (reloading) return <ShellSkeleton />;

  return (
    <div className="route-error" role="alert">
      <h2>{t('route_error_title', 'Não conseguimos abrir esta tela')}</h2>
      <p>
        {chunk
          ? t(
              'route_error_update',
              'O painel foi atualizado. Recarregue a página para usar a versão nova.',
            )
          : t('route_error_generic', 'Recarregue a página. Se continuar, fale com o Suporte.')}
      </p>
      <button type="button" className="button color" onClick={() => window.location.reload()}>
        {t('route_error_reload', 'Recarregar')}
      </button>
    </div>
  );
}
